import Image from '@/components/UI/Image';
import EFArrowDown from '@/components/UI/svg/Icons/EFArrowDown';
import { createEFPic } from '@/utils/useEFPic';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
/**
 * 2022-01-22 k.w 自定义轮滑组件(卡片组件之No.3)
 */

const defaultStyle = {
    theme: 'white',
    wrapperBack: '',
    icon: {
        isAlwaysShow: false, // icon总是显示
        iconPositionBetween: 80, // icon距离容器侧边边距
    },
    list: {
        imgWidth: 360,
        imgHeight: 450,
        listGap: 80, // list之间间隔
        listWidth: 360,
        listHeight: 510,
    },
    animation: {
        translateX: 255, // 容器中初始ul的偏移量
        steps: 1, // 一次滑动list的个数
        duration: 500, // 一次动画效果的时长 ms
        delay: 0, // 动画延迟时间 ms
        fill: 'forwards', // 动画执行是否应用样式 none, forwards, backwords, both, initial, inherit
        easing: 'ease', // 动画执行速度 linear,ease, ease-in, ease-out, ease-in-out, steps(int,start|end), cubic-bezier(n,n,n,n)
        iterations: 1, // 动画执行次数
    },
    textStyle: {
        marginTop: '30px',
        textAlign: 'center',
        lineHeight: '30px',
        fontSize: '22px',
        color: '#03060b',
        fontFamily: 'var(--font-family-Medium)',
        fontWeight: 600,
    },
};

const defaultData = [
    { img: '/img/card-slide-1.png', desc: 'Power your home for days' },
    { img: '/img/card-slide-2.png', desc: 'Power your home for days' },
    { img: '/img/card-slide-3.png', desc: 'Power your home for days' },
    { img: '/img/card-slide-4.png', desc: 'Power your home for days' },
    { img: '/img/card-slide-1.png', desc: 'Power your home for days' },
    { img: '/img/card-slide-2.png', desc: 'Power your home for days' },
];

export default function CardSliderModule({ cssStyle = defaultStyle, data = defaultData }: any) {
    const styles = {
        theme: cssStyle.theme ?? defaultStyle.theme,
        wrapperBack: cssStyle.wrapperBack,
        icon: { ...defaultStyle.icon, ...cssStyle?.icon },
        list: { ...defaultStyle.list, ...cssStyle?.list },
        animation: { ...defaultStyle.animation, ...cssStyle?.animation },
        textStyle: { ...defaultStyle.textStyle, ...cssStyle?.textStyle },
        webpUrl: cssStyle?.webpUrl,
    };
    const { theme, wrapperBack, icon, list, animation, textStyle, webpUrl } = styles;
    const { EFPic } = createEFPic(webpUrl);
    // 背景主题
    const isWhiteTheme = theme === 'white' || theme === '#fff' || theme === '#ffffff' || theme === 'transparent';
    const { useState, useRef, useEffect } = useGlobal();
    const listContainerRef = useRef();
    // 设置偏移量
    const [transformX, setTransformX] = useState(animation.translateX);
    // 记录热键：当前展示区域的第一个list的key
    const [reactiveKey, setReativeKey] = useState(0);
    // 记录完整显示的列表个数：向下取整
    const screenShowItemsNumber = Math.floor((globalThis.innerWidth - animation.translateX) / (list.listWidth + list.listGap));
    // icon是否活性状态（非活性默认不显示）
    const [activeIconPrev, setActiveIconPrev] = useState(false);
    const [activeIconNext, setActiveIconNext] = useState(false);

    /**
     * 动画效果
     * @param steps 动画滑动几张, 默认1
     * @param moveX x轴滑动偏移量(list宽+list间距)
     * @param direction 滑动方向 1: 左滑(上一张) -1. 右滑(下一张)
     */
    const animate = (steps: number, moveX: number, direction: number) => {
        const originX = parseInt(listContainerRef?.current?.style?.transform.split('(')[1]);
        listContainerRef?.current?.animate(
            [{ transform: `translate3d(${originX}px, 0, 0)` }, { transform: `translate3d(${originX + moveX * steps * direction}px, 0, 0)` }],
            {
                duration: animation.duration,
                delay: animation.delay,
                fill: animation.fill,
                easing: animation.easing,
                iterations: animation.iterations,
            },
        );
        setTransformX(originX + moveX * steps * direction);
        setReativeKey(reactiveKey - steps * direction);
    };
    // 左滑
    const clickPrev = () => {
        if (reactiveKey > 0) {
            animate(animation.steps, list.listWidth + list.listGap, 1);
        }
    };
    // 右滑
    const clickNext = () => {
        if (reactiveKey + screenShowItemsNumber < data.length) {
            animate(animation.steps, list.listWidth + list.listGap, -1);
        }
    };

    useEffect(() => {
        setActiveIconPrev(reactiveKey > 0);
        setActiveIconNext(reactiveKey + screenShowItemsNumber < data.length);
    }, [reactiveKey]);

    return (
        <div
            className={`${css.cardSliderModule} cardSliderModule ${isWhiteTheme ? '' : 'black'}`}
            style={{ background: wrapperBack || (isWhiteTheme ? '#fff' : '#000') }}
        >
            <div className="cardSliderWrapper">
                <div
                    className="arrowIcon prevIcon"
                    onClick={clickPrev}
                    style={{
                        display: icon.isAlwaysShow || activeIconPrev ? 'flex' : 'none',
                        width: '52px',
                        height: '52px',
                        top: `${list.imgHeight / 2}px`,
                        left: `${icon.iconPositionBetween}px`,
                    }}
                >
                    <EFArrowDown className="icon" />
                </div>
                <div className="sliderContent" ref={listContainerRef} style={{ transform: `translate3d(${transformX}px, 0,0)` }}>
                    <ul className="listBox">
                        {data.map((item: any, k: number) => (
                            <li
                                className="list"
                                key={k}
                                style={{
                                    marginLeft: k === 0 ? 0 : `${parseInt(list.listGap)}px`,
                                    width: list.listWidth,
                                    height: list.listHeight,
                                }}
                            >
                                <div className="imgBox" style={{ width: `${list.imgWidth}px`, height: `${list.imgHeight}px` }}>
                                    {Array.isArray(item?.img) ? (
                                        <EFPic name={item.img} alt={item.alt || item.desc} />
                                    ) : (
                                        <Image src={item.img} width={list.imgWidth} height={list.imgHeight} alt={item.alt || item.desc} />
                                    )}
                                </div>
                                <p
                                    className="descText"
                                    style={{
                                        ...textStyle,
                                        ...{
                                            display: item.desc ? 'block' : 'none',
                                            color: isWhiteTheme ? '#03060b' : '#919191',
                                        },
                                    }}
                                >
                                    {item.desc}
                                </p>
                            </li>
                        ))}
                    </ul>
                </div>
                <div
                    className="arrowIcon nextIcon"
                    onClick={clickNext}
                    style={{
                        display: icon.isAlwaysShow || activeIconNext ? 'flex' : 'none',
                        width: '52px',
                        height: '52px',
                        top: `${list.imgHeight / 2}px`,
                        right: `${icon.iconPositionBetween}px`,
                    }}
                >
                    <EFArrowDown className="icon" />
                </div>
            </div>
        </div>
    );
}
